exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2{color:tomato}.c-grid{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;margin:0 0 1rem}.c-grid__title{margin:0;padding:.25em 0;text-transform:uppercase}.c-grid__item{margin:0 0 .5rem}.u-ml-auto{margin-left:auto}.u-mb-3{margin-bottom:1.5rem}", ""]);

// exports
